import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    '& > div': {
      margin: '0'
    }
  },
  fullPageHeight: {
    height: '100%',
  },
  loginForm: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  loginFormTitle: {
    fontSize: 35,
    textAlign: 'center',
    fontWeight: 'lighter',
    color: '#156399',
    margin: '4.125rem 0 2rem 0',
  },
  commonInputStyle: {
    margin: '2.5rem 0',
    position: 'relative'
  },
  datePickerInput: {
    '& button': {
      padding: 0,
      margin: 0
    }
  },
  findProfileBtn: {
    width: '100%',
    borderRadius: 23
  },
  errorText: {
    position: 'absolute',
    color: theme.palette.error.main,
    fontWeight: 'bold',
    textShadow: `1px 0 ${theme.palette.background.default}, -1px 0 ${theme.palette.background.default}, 0 1px ${theme.palette.background.default}, 0 -2px ${theme.palette.background.default}, 1px 1px ${theme.palette.background.default}, -1px -1px ${theme.palette.background.default}, 1px -1px ${theme.palette.background.default}, -1px 1px ${theme.palette.background.default}`,
    fontSize: 14,
    margin: '2px 0 0 4px',
  },
}));
